// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NewsHeader-cls1___6aa2d412d24652627e8{/*!*/}.NewsHeader-cls2___ada87c4cf08d84608e9{padding:16px 16px 12px}.NewsHeader-cls2___ada87c4cf08d84608e9.NewsHeader-variant-dense___d7374f831faef7b8000{padding:0 0 12px 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "NewsHeader-cls1___6aa2d412d24652627e8",
	"cls2": "NewsHeader-cls2___ada87c4cf08d84608e9 NewsHeader-cls1___6aa2d412d24652627e8",
	"variant-dense": "NewsHeader-variant-dense___d7374f831faef7b8000"
};
export default ___CSS_LOADER_EXPORT___;
